import React, { useContext, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Accordion, Card } from 'react-bootstrap';
import ButtonCompontent from './ActionComponent';
import { updateCostingStageList, getCostingStageList } from '../Store/SystemMasters.action';
// eslint-disable-next-line import/no-cycle
import CardContent from './CardContent';
import { Context } from './ContextWrapper';
import Loader from '../../../Components/Utility/Loader/Loader';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function CostingStageMaster() {
  const { addNewItem, cards, updateSubmitState, formState, OpenReArrangeFunction, MasterAddEditAccess } = useContext(Context);
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const selecter = useSelector((state) => state);
  const {
    UserDetails: { userInfo },
  } = selecter;
  const [openCard, setOpenCard] = useState(false);

  const switchCardState = () => {
    setOpenCard((prev) => !prev);
  };

  const handleClick = async () => {
    try {
      updateSubmitState(true);
      if (Object.keys(formState?.errors)?.length) {
        return;
      }
      const ew = cards.map((obj) => {
        if (obj._id.includes('_id')) {
          return { ...obj, _id: '' };
        }
        return obj;
      });
      const objData = {
        loggedInUserId: userInfo.userId,
        names: JSON.stringify(ew),
      };

      await dispatch(updateCostingStageList(objData, t));
      await dispatch(getCostingStageList({ loggedInUserId: userInfo.userId }));
      updateSubmitState(false);
    } catch (error) {}
  };
  return (
    <Accordion className="mb-4 master-accordian">
      <Card>
        <Card.Header>
          <div className="title-container">
            <p>{t('COSTING_STAGE_MASTER.COSTING_STAGE')}</p>
          </div>
          <div className="action-title-btns">
            {MasterAddEditAccess && (
              <button
                type="button"
                onClick={() => OpenReArrangeFunction('coastingStage')}
                className="filter-btn filter-button_add"
                disabled={formState?.isLoading || formState?.disableBtn}
                aria-label="Rearrange"
                title={t('COSTING_STAGE_MASTER.REARRANGE')}
              >
                <span className="icon-expand" />
              </button>
            )}
            {MasterAddEditAccess && (
              <ButtonCompontent
                icon="icon-add"
                isDisabled={formState?.isLoading || formState?.disableBtn}
                tooltipText={t('COSTING_STAGE_MASTER.ADD')}
                show
                onClick={addNewItem}
              />
            )}
            <ButtonCompontent
              icon={openCard ? 'icon-new-up' : 'icon-new-down'}
              isDisabled={false}
              tooltipText={openCard ? t('COSTING_STAGE_MASTER.CLOSE') : t('COSTING_STAGE_MASTER.OPEN')}
              show
              onClick={switchCardState}
            />
          </div>
        </Card.Header>
        {openCard ? (
          <Card.Body>
            {formState?.isLoading ? (
              <Loader />
            ) : (
              <>
                <CardContent />
                {MasterAddEditAccess && (
                  <div className="section-save">
                    <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                      <button className="btn btn-page-filter btn-white ml-auto" type="submit" onClick={handleClick} aria-label="Save">
                        <span className="icon-Save c-button-align f-20 mr-2" /> {t('COSTING_STAGE_MASTER.SAVE')}
                      </button>
                    </CustomTooltip>
                  </div>
                )}
              </>
            )}
          </Card.Body>
        ) : null}
      </Card>
    </Accordion>
  );
}

export default CostingStageMaster;
